import { useEffect, useState } from "react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, useWatch } from "react-hook-form";
import { Details, Edit } from "../../services/offer.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const FormSchema = z
  .object({
    name: z.string().min(3),
    description: z.string().min(5),
    offered_price: z.coerce.number().min(1, "Price must be greater than 0"),
    limit_per_person: z.coerce.number().min(1, "Must be at least 1"),
    status: z.enum(["ACTIVE", "INACTIVE"]),
    expiry_date: z.coerce.date().min(new Date("2025-08-01"), { error: "Too old!" }),
  })
  .superRefine((data, ctx) => {
  });

export default function EditBusinessCoupons() {
  const [discountType, setDiscountType] = useState("");
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Details(id);
        console.log(response);
        if (response.success) {
          form.setValue("name", response.data.name);
          form.setValue("status", response.data.status === true ? "ACTIVE" : "INACTIVE");
          form.setValue("expiry_date", response.data.expiry_date ? new Date(response.data.expiry_date).toISOString().split("T")[0] : "");
          form.setValue("description", response.data.description);
          form.setValue("offered_price", response.data.offered_price);
          form.setValue("limit_per_person", response.data.limit_per_person);
          // form.setValue("discountType", response.data.discountType);
          // form.setValue("discountValue", response.data.discountValue);
          // form.setValue("buyXQty", response.data.buyXQty);
          // form.setValue("freeYQty", response.data.freeYQty);
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Failed to fetch coupon details",
            ...SWAL_SETTINGS,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: error?.response?.data?.message || "Something went wrong",
          ...SWAL_SETTINGS,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      name: "",
      status: "",
      expiry_date: "",
      offered_price: "",
      limit_per_person: "",
      description: ""
      // discountType: "PERCENTAGE_DISCOUNT",
      // discountValue: "",
      // buyXQty: "",
      // freeYQty: "",
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = form;

  const watchAll = useWatch({ control });
  const watchDiscountType = watch("discountType");

  // useEffect(() => {
  //   setDiscountType(watchDiscountType);
  // }, [watchAll, watchDiscountType]);

  // useEffect(() => {
  //   if (discountType === "BUY_X_GET_Y_FREE") {
  //     setValue("discountValue", undefined);
  //   } else {
  //     setValue("buyXQty", undefined);
  //     setValue("freeYQty", undefined);
  //   }
  // }, [discountType, setValue]);

  // Generate coupon code
  const generateCouponCode = () => {
    const code = Math.random().toString(36).substring(2, 12).toUpperCase();
    setValue("code", code);
  };

  async function onSubmit(data) {
    try {
      const response = await Edit({ _id: id, ...data, status: data.status === "ACTIVE" ? true : false });
      
      if (response.success) {
        Swal.fire({
          icon: "success",
          text: response.message,
          ...SWAL_SETTINGS,
        });
        setTimeout(() => {
          navigate("/business/coupons/1");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          text: response.message,
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      console.log(error);
      console.log(error.message);
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Something went wrong",
        ...SWAL_SETTINGS,
      });
    }
  }

  return (
    <div className="main-content">
      <div className="support-part">
        <div className="card-box">
          <div className="mx-auto">
            <h3 className="h3-headline text-center mb-4">Edit Offer</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-3 text-start">
                {/* Coupon Title */}
                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="title">
                    Offer Title<span className="requirestar">*</span>
                  </label>
                  <input {...register("name")} type="text" className="form-control" id="title" placeholder="Enter Offer title" />
                  {errors.name && <p className="text-danger mt-1">{errors.name.message}</p>}
                </div>

           

 

                {/* Offered Price */}
                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="offered_price">
                    Offered Price<span className="requirestar">*</span>
                  </label>
                  <input {...register("offered_price")} type="number" className="form-control" id="offered_price" placeholder="Enter Offer offer price" />
                  {errors.offered_price && <p className="text-danger mt-1">{errors.offered_price.message}</p>}
                </div>

                {/* Limit Per Person */}
                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="limit_per_person">
                    Limit Per Person<span className="requirestar">*</span>
                  </label>
                  <input {...register("limit_per_person")} type="number" className="form-control" id="limit_per_person" placeholder="Enter limit per person" />
                  {errors.limit_per_person && <p className="text-danger mt-1">{errors.limit_per_person.message}</p>}
                </div>

                <div className="col-md-6">
                  <label className="form-label subtitle-1" htmlFor="expiryDate">
                    Expiry Date<span className="requirestar">*</span>
                  </label>
                  <input {...register("expiry_date")} type="date" className="form-control" id="expiryDate" placeholder="Enter expiry date" />
                  {errors.expiry_date && <p className="text-danger mt-1">{errors.expiry_date.message}</p>}
                </div>

                <div className="col-md-12">
                  <label className="form-label subtitle-1" htmlFor="description">
                    Description<span className="requirestar">*</span>
                  </label>
                  <textarea {...register("description")} className="form-control form-control-business" id="description" placeholder="Enter description" rows={5} />
                  {errors.description && <p className="text-danger mt-1">{errors.description.message}</p>}
                </div>
              </div>

              <div className="text-center mt-5">
                <button disabled={loading} type="submit" className="btn btn-light-purple px-5">
                  Update Offer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
